export const MODE = {
  LIVE: 'LIVE',
  TEST: 'TEST',
};
